{
  "cash": "Liquidités",
  "noCashAssetClassFound": "Aucune classe d'actifs de liquidités trouvée dans les branches configurées. Veuillez d'abord ajouter une branche de classe d'actifs de liquidités.",
  "cashFetchError": "Impossible de récupérer le produit financier de liquidités. Veuillez réessayer.",
  "other": "Autre",
  "editModel": "Modifier le modèle",
  "details": "Détails",
  "disclaimer": "Avis de non-responsabilité",
  "auditLog": "Rapport d'activité",
  "portfolioAllocation": "Allocation de portefeuille",
  "investmentPolicyStatement": "Énoncé de la politique de placement",
  "selectModel": "Sélectionner ou créer un modèle dans la liste",
  "primaryAssetClasses": "Catégories d'actifs primaires",
  "secondaryAssetClasses": "Catégories d'actifs secondaires",
  "securities": "Valeurs mobilières",
  "name": "Nom",
  "percentage": "Pourcentage",
  "taxRank": "Rang d'imposition",
  "secondaryAssetClass": "Catégorie d'actifs",
  "minimum": "Minimum",
  "maximum": "Maximum",
  "actual": "Réel",
  "unknown": "Inconnu",
  "transition": {
    "draft": "Déplacer dans les brouillons",
    "activate": "Déplacer dans les éléments actifs",
    "archive": "Déplacer dans les archives"
  },
  "transitionTheme": {
    "successfulTransition": "Thème correctement transféré",
    "unableToArchiveError": "Archivage impossible. Ce thème est actuellement attribué à {{numActivePortfolios}} portefeuilles actifs.",
    "archiveConfirmationModal": {
      "title": "Voulez-vous vraiment archiver cet élément?",
      "confirm": "Confirmer",
      "cancel": "Annuler"
    }
  },
  "themeModal": {
    "updateTitle": "Mettre à jour le thème",
    "title": "Créer un nouveau thème",
    "key": "Clé",
    "name": "Nom",
    "description": "Description",
    "shortDescription": "Description courte",
    "organization": "Organisation",
    "defaultRecommendation": "Recommandation par défaut",
    "iconKey": "Icône",
    "successMessages": {
      "create": "Le thème a été correctement créé.",
      "update": "Le thème a été correctement mis à jour."
    },
    "errorMessages": {
      "create": "Impossible de créer le thème. Veuillez réessayer.",
      "update": "Impossible de mettre à jour le thème. Veuillez réessayer."
    }
  },
  "modelModal": {
    "title": "Créer un nouveau modèle",
    "name": "Nom",
    "organization": "Organisation"
  },
  "core": "PRINCIPAL",
  "edit": {
    "name": "Nom",
    "porfolioDescription": "Description",
    "investmentObjective": "Objectif de l'investissement",
    "theme": "Thème",
    "suggestable": "Influençable",
    "forecastedRateOfReturn": "Taux de rendement prévu",
    "forecastedStandardDeviation": "Écart-type prévu",
    "lowThresholdScore": "Score le plus bas",
    "suggestedMinScore": "Score minimal",
    "suggestedMaxScore": "Score maximal",
    "riskReturnLevel": "Niveau de risque/rendement",
    "save": "Enregistrer",
    "post": "Publier",
    "triggerReSign": {
      "button": "Déclencher une nouvelle signature des énoncés de la politique de placement",
      "triggerButton": "Déclencher",
      "confirmationTitle": "Voulez-vous vraiment que les clients signent à nouveau le contrat?",
      "confirmationMessage": "Si vous poursuivez, tous les clients qui possèdent ce portefeuille devront signer à nouveau ce contrat pour que leurs comptes soient rééquilibrés.",
      "updateReason": "Mettre à jour le motif",
      "toastMessage": "Une nouvelle signature des énoncés de la politique de placement a été déclenchée."
    },
    "disclaimerMarkdownLabel": "Avis de non-responsabilité du portefeuille",
    "clear": "Effacer",
    "liquidityInfo": "Liquidité",
    "url": "Lien vers les détails du fonds"
  },
  "editAllocation": {
    "updatedToastMessage": "Les allocations de modèles de portefeuille ont été mise à jour."
  },
  "editAccount": {
    "title": "Modifier le numéro de compte",
    "accountNumber": "Numéro de compte",
    "update": "Mettre à jour le numéro de compte"
  },
  "editTlh": {
    "title": "Activer la réalisation des pertes fiscales",
    "true": "Oui",
    "false": "Non"
  },
  "newNote": {
    "title": "Rédiger une note",
    "characters": "caractères",
    "clear": "OUI, EFFACER",
    "cancelClear": "NON, NE PAS EFFACER",
    "delete": "OUI, SUPPRIMER",
    "cancelDelete": "NON, NE PAS SUPPRIMER",
    "deleteTitle": "Supprimer la note",
    "deleteSubText": "Voulez-vous vraiment supprimer cette note?",
    "clearTitle": "Supprimer la note",
    "clearSubText": "Voulez-vous vraiment effacer cette note?",
    "deleteWarning": "Vous ne disposez pas de l'autorisation nécessaire pour supprimer cette note.",
    "updateWarning": "Vous ne disposez pas de l'autorisation nécessaire pour mettre à jour cette note.",
    "noteUserPostFix": "  ajouté :",
    "thereAreNoNotes": "Aucune note à afficher"
  },
  "update": "Mettre à jour"
}
